import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SafeAreaAdapter } from 'src/app/adapters/safe-area/safe-area.adapter';
import { SafeAreaConfig } from 'src/app/adapters/safe-area/safe-area.config';

@Injectable({
  providedIn: 'root'
})
export class SafeAreaUseCase {
  constructor(
    private readonly adapter: SafeAreaAdapter,
  ) {}

  enable(config: SafeAreaConfig): Observable<void> {
    const obs = this.adapter.enable(config);
    return obs;
  }
}